// extracted by mini-css-extract-plugin
export default {"ammoTypes":"styles_ammoTypes__9wax4","ammoName":"styles_ammoName__5uoJo","ammoMarker":"styles_ammoMarker__d-Y-H","selected":"styles_selected__2xKRA","data":"styles_data__OcD5a"};